<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="rightSearch()" #form="ngForm" class="form-validate">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          <i class="bi bi-box me-2"></i>แหล่งข้อมูล
        </label>
        <div class="col-auto">
          <app-btn-lk2 [(source)]="source"></app-btn-lk2>
        </div>
      </div>
      <hr>
      <div class="row mb-3">
        <label for="personalId" class="col-form-label col-auto">เลขประจำตัวประชาชน</label>
        <div class="col-auto">
          <input type="text" class="form-control" id="personalId" [ngModel]="personalId()" name="personalId"
                 formDisabled>
        </div>
        <label for="personalId" class="col-form-label col-auto">วันที่ตรวจสอบ/วันที่เข้ารับบริการ</label>
        <div class="col-auto">
          <gt-ng-datepicker [(ngModel)]="checkDate" [maxDate]="maxDate()" name="checkDate"></gt-ng-datepicker>
        </div>

        <label for="checkTime" class="col-form-label col-auto">เวลา</label>
        <div class="col-auto">
          <ngb-timepicker id="checkTime" name="checkTime" [(ngModel)]="checkTime" [spinners]="false"/>
        </div>
        <label for="checkTime" class="col-form-label col-auto">น.</label>

        <div class="col-auto">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-search me-1"></i>ตรวจสอบสิทธิ
          </button>
          <button (click)="resetSearchParams()" type="button" class="btn btn-default mx-2">
            ล้างค่า
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
@if (data()?.personalData) {
  <app-right-detail [data]="data()" (onTabChange)="onTabChange($event)" [menu]="fromMenu()"></app-right-detail>
  @if (canBeRegistered() && !registrantType) {
    <ng-container
      *hasAnyAuthority="['admin', 'nhso', 'regis_zone', 'senior_regis', 'staff_call_center', 'regis_call_center']; except: ['chk_right', 'reg_chk_right']">
      <app-register-panel (onSelectRegistrantType)="register($event)"
                          [redirectUrl]="['/secure/registration/personal-id/forms']"></app-register-panel>
    </ng-container>
  } @else {
    <ng-container
      *hasAnyAuthority="['admin', 'nhso', 'regis_zone', 'senior_regis', 'staff_call_center', 'regis_call_center']; except: ['chk_right', 'reg_chk_right']">
      <app-register-proxy [data]="data()" [registerMethod]="'THAID'"></app-register-proxy>
    </ng-container>
  }
} @else {
  <app-not-found></app-not-found>
}
